// import qs from 'qs';

import * as constType from '@js/constants/actionsTypes';
import {
  finalMmmHomeAdvData,
  finalZhMMMSauceAdvData,
  finalZhMMMNoodlesAdvData,
  finalZhMMMVideosAdvData,
} from '@js/controller/MmmController';

const mmmMiddleware = (store) => (next) => (action) => {
  switch (action.type) {
    // zhMMMHomeAdv
    case 'MID_GET_MMM_HOME_ADV': {
      store.dispatch({
        type: constType.CHANGE_EFFECT_ISLOADING,
        payload: true,
      });
      store.dispatch({
        type: constType.GET_MMM_HOME_ADV,
        payload: finalMmmHomeAdvData,
      });
      store.dispatch({
        type: constType.CHANGE_EFFECT_ISLOADING,
        payload: false,
      });
      return next(action);
    }
    // zhMMMSauceAdv
    case 'MID_GET_ZH_MMM_SAUCE_ADV': {
      store.dispatch({
        type: constType.CHANGE_EFFECT_ISLOADING,
        payload: true,
      });
      store.dispatch({
        type: constType.GET_ZH_MMM_SAUCE_ADV,
        payload: finalZhMMMSauceAdvData,
      });
      store.dispatch({
        type: constType.CHANGE_EFFECT_ISLOADING,
        payload: false,
      });
      return next(action);
    }
    // zhMMMNoodlesAdv
    case 'MID_GET_ZH_MMM_NOODLES_ADV': {
      store.dispatch({
        type: constType.CHANGE_EFFECT_ISLOADING,
        payload: true,
      });
      store.dispatch({
        type: constType.GET_ZH_MMM_NOODLES_ADV,
        payload: finalZhMMMNoodlesAdvData,
      });
      store.dispatch({
        type: constType.CHANGE_EFFECT_ISLOADING,
        payload: false,
      });
      return next(action);
    }
    // zhMMMVideosAdv
    case 'MID_GET_ZH_MMM_VIDEOS_ADV': {
      store.dispatch({
        type: constType.CHANGE_EFFECT_ISLOADING,
        payload: true,
      });
      store.dispatch({
        type: constType.GET_ZH_MMM_VIDEOS_ADV,
        payload: finalZhMMMVideosAdvData,
      });
      store.dispatch({
        type: constType.CHANGE_EFFECT_ISLOADING,
        payload: false,
      });
      return next(action);
    }
    default:
      return next(action);
  }
};

export default mmmMiddleware;
